import "../../../../css/modal/EditRegisterDueModal.css"
import "../../../../css/modal/ModalInput.css";
import { useState, useEffect } from "react"
import { limitInputNumber, getDateString, checkValidDateWithPattern, moveModal } from "../../../../utils/Utils"
import proxy from "../../../../utils/Proxy";

let EditRegisterDueModal = (props) => {
    let [valid1, setValid1] = useState(true)
    let [valid2, setValid2] = useState(true)
    let [lessonDue, setLessonDue] = useState(1)

    let today = new Date()
    let todayString = getDateString(today)

    let onChangeStart = (e, limit) => {
        limitInputNumber(e, limit);
        let validDate = checkValidDateWithPattern("register-due-edit-start-input-year", "register-due-edit-start-input-month", "register-due-edit-start-input-day");
        setValid1(validDate)

        if (!validDate) {
            document.getElementById("register-due-edit-start-invalid-message").innerHTML = "날짜 형식이 아닙니다.";
        }
        else {
            document.getElementById("register-due-edit-start-invalid-message").innerHTML = "";
            document.getElementById("register-due-edit-end-invalid-message").innerHTML = "";

            autoChangeEnd(lessonDue)
        }
    }

    let autoChangeEnd = (months) => {
        setValid2(true)
        document.getElementById("register-due-edit-end-auto-change-guide").innerHTML = "자동 수정됨!";
        setTimeout(() => {
            if (!document.getElementById("register-due-edit-end-auto-change-guide")) return
            document.getElementById("register-due-edit-end-auto-change-guide").innerHTML = "";
        }, 1000)

        let startYear = document.getElementById("register-due-edit-start-input-year").value
        let startMonth = document.getElementById("register-due-edit-start-input-month").value
        let startDay = document.getElementById("register-due-edit-start-input-day").value

        let start = new Date(startYear, startMonth - 1, startDay)
        let endDay = new Date(start.getFullYear(), start.getMonth() + months, start.getDate() - 1)
        let endDayString = getDateString(endDay)
        document.getElementById("register-due-edit-end-input-year").value = endDayString.slice(0, 4)
        document.getElementById("register-due-edit-end-input-month").value = endDayString.slice(5, 7)
        document.getElementById("register-due-edit-end-input-day").value = endDayString.slice(8, 10)
    }

    let onChangeEnd = (e, limit) => {
        limitInputNumber(e, limit);

        let invalidMessage = "";
        let valid = true;

        let validDate = checkValidDateWithPattern("register-due-edit-end-input-year", "register-due-edit-end-input-month", "register-due-edit-end-input-day");
        if (!validDate) {
            valid = false;
            invalidMessage = "날짜 형식이 아닙니다.";
        }
        else {
            let startYear = document.getElementById("register-due-edit-start-input-year").value
            let startMonth = document.getElementById("register-due-edit-start-input-month").value
            let startDay = document.getElementById("register-due-edit-start-input-day").value
            let start = new Date(startYear, startMonth, startDay)

            let endYear = document.getElementById("register-due-edit-end-input-year").value
            let endMonth = document.getElementById("register-due-edit-end-input-month").value
            let endDay = document.getElementById("register-due-edit-end-input-day").value
            let end = new Date(endYear, endMonth, endDay)
            if (end < start) {
                valid = false;
                invalidMessage = "종료일이 시작일 보다 작을 수 없습니다."
            }
        }
        setValid2(valid)
        document.getElementById("register-due-edit-end-invalid-message").innerHTML = invalidMessage;
    }

    let onSubmitClick = () => {
        let dialogResult = window.confirm("저장 하시겠습니까?");
        if (!dialogResult) return;

        // valid check
        if (!valid1 || !valid2) {
            window.alert("다시 입력하세요.");
            return;
        }
        let startYear = document.getElementById("register-due-edit-start-input-year").value
        let startMonth = document.getElementById("register-due-edit-start-input-month").value
        let startDay = document.getElementById("register-due-edit-start-input-day").value
        let start = startYear + "-" + startMonth + "-" + startDay

        let endYear = document.getElementById("register-due-edit-end-input-year").value
        let endMonth = document.getElementById("register-due-edit-end-input-month").value
        let endDay = document.getElementById("register-due-edit-end-input-day").value
        let end = endYear + "-" + endMonth + "-" + endDay
        proxy.put("/adminapi/payments/" + props.data.paymentid, { start: start, end: end }).then(() => {
            window.alert("변경 되었습니다.");
            props.onSubmitRegisterDue();
        }).catch(res => window.alert(res.response.data.message));
    }

    let cancelModal = () => {
        let dialogResult = window.confirm("취소 하시겠습니까?")
        if (dialogResult)
            props.onCloseClick();
    }

    useEffect(() => {
        proxy.get("/adminapi/payments/" + props.data.paymentid).then(res => {
            let payment = res.data.data;
            setLessonDue(payment.months)
            autoChangeEnd(payment.months)
        }).catch(err => {
            window.alert(err.response.data.message);
        })
    })

    return (
        <div className="modal-container">
            <div className="modal" id="edit-register-due-modal">
                <div className="modal-content-container">
                    <div className="modal-header" onMouseDown={e => moveModal(e, "edit-register-due-modal")}>
                        <p className="modal-title">
                            수강생 등록기간 설정
                        </p>
                        <div className="modal-close-button" onClick={cancelModal}></div>
                    </div>
                    <div className="modal-content" id="edit-register-due-modal-content">
                        <div className="modal-content-items-container">
                            <div className="modal-content-item modal-content-align-start">
                                <div className="modal-content-divider-2" id="edit-register-due-content-left">
                                    <p className="modal-content-text">레슨 기간</p>
                                </div>
                                <div className="modal-content-divider-2" id="edit-register-due-content-right">
                                    <p>{lessonDue}개월</p>
                                </div>
                            </div>
                        </div>
                        <div className="modal-content-items-container">
                            <div className="modal-content-item modal-content-align-start">
                                <div className="modal-content-divider-2" id="edit-register-due-content-left">
                                    <p className="modal-content-text">등록 기간</p>
                                </div>
                                <div className="modal-content-divider-2" id="edit-register-due-content-right">
                                    <div className="edit-register-due-input-container">
                                        <div className={(valid1 ?
                                            "modal-input" : "modal-input-invalid")} id="edit-register-due-start-input-wrapper">
                                            <input className="modal-input-date" id="register-due-edit-start-input-year"
                                                defaultValue={todayString.slice(0, 4)} onChange={e => onChangeStart(e, 4)}
                                                pattern="\d{4}" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date" id="register-due-edit-start-input-month"
                                                defaultValue={todayString.slice(5, 7)} onChange={e => onChangeStart(e, 2)}
                                                pattern="0?[1-9]|1[0-2]" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date" id="register-due-edit-start-input-day"
                                                defaultValue={todayString.slice(8, 10)} onChange={e => onChangeStart(e, 2)}
                                                required></input>
                                        </div>
                                        <p className="modal-input-invalid-message" id="register-due-edit-start-invalid-message"></p>
                                    </div>

                                    <div className="eidt-register-due-divider">
                                        <p>~</p>
                                    </div>
                                    <div className="edit-register-due-input-container">
                                        <div className={(valid2 ?
                                            "modal-input" : "modal-input-invalid")} id="edit-register-due-end-input-wrapper">
                                            <input className="modal-input-date edit-register-due-end-input" id="register-due-edit-end-input-year"
                                                onChange={e => onChangeEnd(e, 4)}
                                                pattern="\d{4}" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date edit-register-due-end-input" id="register-due-edit-end-input-month"
                                                onChange={e => onChangeEnd(e, 2)}
                                                pattern="0?[1-9]|1[0-2]" required></input>
                                            <p>-</p>
                                            <input className="modal-input-date edit-register-due-end-input" id="register-due-edit-end-input-day"
                                                onChange={e => onChangeEnd(e, 2)}
                                                required></input>
                                        </div>
                                        <p className="modal-input-invalid-message" id="register-due-edit-end-invalid-message"></p>
                                        <p className="modal-input-hint-message" id="register-due-edit-end-auto-change-guide"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" >
                        <div className="modal-footer-button-container">
                            <div className="modal-button" onClick={onSubmitClick} >
                                <p>변경</p>
                            </div>
                            <div className="modal-button" onClick={cancelModal}>
                                <p>취소</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditRegisterDueModal;